import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n\n    ", "\n    ", "\n    \n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes, widthAttributes } from '../../system';
import { getPropsBlocker } from '../../utils';
var propertyList = {
  autoMargin: true,
  enableVerticalOuterSpacing: true
};

var getRootBaseStyle = function getRootBaseStyle(_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.FormField.Root.base;
};

var getRootDynamicStyle = function getRootDynamicStyle(_ref2) {
  var theme = _ref2.theme,
      enableVerticalOuterSpacing = _ref2.enableVerticalOuterSpacing;
  var FormField = theme.componentOverrides.FormField;

  if (enableVerticalOuterSpacing) {
    return FormField.Root.autoMargin;
  }

  return '';
};

export var FormFieldRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), getRootBaseStyle, getRootDynamicStyle, marginAttributes, widthAttributes);